import * as React from 'react';
import { connect } from 'react-redux';
import { getQuestionnaireEvaluationQuestionAttributeType } from "../../questionnaireEvaluation";
import { photoCaptureIntelligentAddFileToIterationAction, photoCaptureIntelligentDeleteAttachmentIterationAction, photoCaptureIntelligentViewChangeAction, photoCaptureIntelligentUpdateIterationUploadingStatusAction, photoCaptureIntelligentResetSaveCapturedPhotoAction, photoCaptureIntelligentSaveCapturedPhotoAction } from '../actions';
import { IntelligentPhotoCaptureEstimatorCameraView } from '../components';
import { getAttachmentIterationInfo, getShouldUseIntegratedCamera, getIntelligentCapturedPhotoFile, getIntelligentEstimatorSelectedTileId, getIntelligentPhotoCaptureLastRenderedView, getIntelligentSequenceScreenName, getPhotoCaptureUserVehicleInfo, getPhotoCaptureVehicle } from '../selectors';
const mapStateToProps = (state) => {
    return {
        attachmentIterationInfo: getAttachmentIterationInfo(state),
        capturedPhoto: getIntelligentCapturedPhotoFile(state),
        estimatorSelectedTileId: getIntelligentEstimatorSelectedTileId(state),
        lastRenderedView: getIntelligentPhotoCaptureLastRenderedView(state),
        questionSubType: getQuestionnaireEvaluationQuestionAttributeType(state),
        sequenceScreenName: getIntelligentSequenceScreenName(state),
        userVehicleInfo: getPhotoCaptureUserVehicleInfo(state),
        vehicle: getPhotoCaptureVehicle(state),
        shouldUseIntegratedCamera: getShouldUseIntegratedCamera(state)
    };
};
const mapDispatchToProps = (dispatch) => ({
    onViewChange: (view, sequenceScreenName, selectedTileId) => {
        dispatch(photoCaptureIntelligentViewChangeAction(view, sequenceScreenName, selectedTileId));
    },
    onHandleCameraFile: (file) => {
        dispatch(photoCaptureIntelligentAddFileToIterationAction(file));
    },
    onResetCapturedPhoto: () => {
        dispatch(photoCaptureIntelligentResetSaveCapturedPhotoAction());
    },
    onSaveCapturedPhoto: (file) => {
        dispatch(photoCaptureIntelligentSaveCapturedPhotoAction(file));
    },
    onDeleteAttachmentIteration: (iterationId) => {
        dispatch(photoCaptureIntelligentDeleteAttachmentIterationAction(iterationId));
    },
    onUpdateIterationUploadingStatus: (iteration, uploadingStatus) => {
        dispatch(photoCaptureIntelligentUpdateIterationUploadingStatusAction(iteration.iterationId, uploadingStatus));
    }
});
const IntelligentPhotoCaptureEstimatorCameraViewWrapper = (props) => {
    return (React.createElement(IntelligentPhotoCaptureEstimatorCameraView, Object.assign({}, props, { onUpdateIterationUploadingStatus: (iteration, uploadingStatus) => props.onUpdateIterationUploadingStatus && props.onUpdateIterationUploadingStatus(iteration, uploadingStatus) })));
};
export const ConnectedIntelligentPhotoCaptureEstimatorCameraView = connect(mapStateToProps, mapDispatchToProps)(IntelligentPhotoCaptureEstimatorCameraViewWrapper);
//# sourceMappingURL=ConnectedIntelligentPhotoCaptureEstimatorCameraView.js.map